import template from './cranes.jade';
import originalItems from '../../../enums/crane-types';
import validation from '../../../services/validation';

const items = originalItems.map((item, index) => {
  return {
    ...item,
    inputName: `building.cranageTypes.${index}`,
  };
});

export default angular.module('cian.addForm.cranes', []).directive('cianAfAboutObjectCranes', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'deviceService',
    function (deviceService) {
      this.isMobile = deviceService.isMobile;
      this.ad.building = this.ad.building || {};
      this.ad.building.cranageTypes = this.ad.building.cranageTypes || [];

      this.items = items.map(originalItem => {
        const item = { ...originalItem };
        const itemType = item.value;
        const itemInModel =
          this.ad.building.cranageTypes.find(item => item.type === itemType) ||
          (this.ad.building.cranageTypes.push({ type: itemType }) &&
            this.ad.building.cranageTypes[this.ad.building.cranageTypes.length - 1]);
        Object.defineProperty(item, 'count', {
          get() {
            return itemInModel.count;
          },
          set(value) {
            itemInModel.count = value;
          },
        });

        Object.defineProperty(item, 'loadCapacity', {
          get() {
            return itemInModel.loadCapacity;
          },
          set(value) {
            itemInModel.loadCapacity = value;
          },
        });

        item.validation = validation(this.form, item.inputName + '.count', {
          parse: 'Введите число',
          min: 'Введите число',
          maxlength: 'Введите число',
          max: 'Допустимо не более 2 символов',
        });

        item.validationCapacity = validation(this.form, item.inputName + '.loadCapacity', {
          parse: 'Введите число',
          min: 'Введите число',
          maxlength: 'Введите число',
          max: 'Допустимо не более 3 символов',
        });

        return item;
      });

      this.minCount = 0;
      this.maxCount = 999;

      this.onCountChange = crane => {
        if (!crane.count) {
          crane.loadCapacity = null;
        }
      };
    },
  ],
  controllerAs: 'cranes',
  template,
})).name;
